import { addNavMenuItem } from '@bb-vendure/admin-ui/core';

export default [
  addNavMenuItem(
    {
      id: 'queue-settings',
      label: 'system.queue-settings.nav-label',
      routerLink: ['/extensions/queue-settings'],
      icon: 'users',
      requiresPermission: 'UpdateSettings',
    },
    'settings'
  ),
];
